import React from 'react';
import { StandardButton, type IStandardButton } from '@soulhx/ui-common';

type IStyledButton = IStandardButton & { rpVariant?: string };
export const StyledButton = ({ rpVariant, ...props }: IStyledButton) => {
  return (
    <StandardButton
      variant={
        rpVariant === 'completed'
          ? 'outline-success'
          : rpVariant === 'imminent'
          ? 'outline-dark'
          : rpVariant === 'overdue'
          ? 'outline-danger'
          : 'outline-secondary'
      }
      className="mx-1 border-0"
      {...props}
    />
  );
};
